import React from 'react';
import { Avatar, List, Skeleton, Switch } from 'antd';

const SkeletenLoading = ({size = 30}) => {
  return  <Skeleton.Button active  size={size}/>
  
}


export default SkeletenLoading